module.exports = __webpack_public_path__ + "static/media/hexicon.f5cb1cf4.png";